import { render, staticRenderFns } from "./ConteosPendientes.vue?vue&type=template&id=388038ab&scoped=true&"
import script from "./ConteosPendientes.vue?vue&type=script&lang=js&"
export * from "./ConteosPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388038ab",
  null
  
)

export default component.exports